import "./RecentReviews.css";

import {
  MdStar,
  MdStarBorder,
} from "react-icons/md";

function RecentReviews({ recentReviews = [] }) {

  return (

    <div className="recent-reviews">

      <div className="review-header">

        <h2>
          Recent Reviews
        </h2>

      </div>

      {recentReviews.length === 0 ? (

        <div className="empty-review">

          <p>No reviews yet.</p>

        </div>

      ) : (

        recentReviews.map((review) => (

          <div
            className="review-card"
            key={review._id || review.id}
          >

            <div className="review-top">

              <h4>

                {review.customerName ||
                  review.customer ||
                  "Customer"}

              </h4>

              <div className="stars">

                {[1, 2, 3, 4, 5].map((star) =>

                  star <= review.rating ? (

                    <MdStar key={star} />

                  ) : (

                    <MdStarBorder key={star} />

                  )

                )}

              </div>

            </div>

            <p>

              {review.review ||
                review.comment ||
                "No review available."}

            </p>

            <small className="review-time">

              {review.time ||
                review.createdAt ||
                ""}

            </small>

          </div>

        ))

      )}

    </div>

  );

}

export default RecentReviews;